import React from 'react';
import '../../App.css';
import MrBillingForm from '../MrBillingForm';

function MrBilling({ sessionObject }) {
    // if (!sessionObject.sessionVariables["modules"].includes("mr-billing")) {
    //     return;
    // }
    return (
        <div className="page-mr">
            <MrBillingForm sessionObject={sessionObject} />
        </div>
    );
}

export default MrBilling;